enum SchemaType {
    Object = "object",
    Array = "array",
    String = "string",
    Currency = "currency",
    Time = "time",
    Date = "date",
    DateTime = "datetime",
    Image = "image",
    Integer = "integer",
    Float = "float",
    Text = "text",
}

export default SchemaType;